import { render } from "./ProductOptionField.vue?vue&type=template&id=c661ecce"
import script from "./ProductOptionField.vue?vue&type=script&lang=js"
export * from "./ProductOptionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__